module.exports = ".warning {\n  margin-top: 16px;\n  color: #f86060;\n  font-size: 16px;\n  line-height: 1.3;\n  font-weight: bold; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/nova-gto/planos-tratamento/filtro-planos/filtro-planos.component.scss
// module id = ./src/app/components/nova-gto/planos-tratamento/filtro-planos/filtro-planos.component.scss
// module chunks = main